import React from 'react';
import {TableBasic} from './styles';

export default () => (
  <TableBasic>
    <thead>
      <tr>
        <th colSpan={1} className="transparent"></th>
        <th colSpan={3} className="header-centered left-radio">
          SEASON
        </th>
      </tr>
      <tr>
        <th className="header-centered">PLAYER</th>
        <th className="header-centered">TOTAL INNINGS</th>
        <th className="header-centered">AVG. PITCH COUNT</th>
        <th className="header-centered">STRIKE</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
    </tbody>
  </TableBasic>
);
